export default{
	GetRequest:function() {
	    var url = location.search; //获取url中"?"符后的字串 
	    var theRequest = new Object();
	    if (url.indexOf("?") != -1) {
	        var str = url.substr(1);
	        var strs = str.split("&");
	        for (var i = 0; i < strs.length; i++) {
	            theRequest[strs[i].split("=")[0]] = decodeURIComponent(strs[i].split("=")[1]);
	        }
	    }
	    return theRequest;
	},
	GetQueryString: function () {
		var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
		var r = window.location.search.substr(1).match(reg);
		if(r!=null)return  decodeURIComponent(r[2]);
		return null;
	},
	getPhotoUrl:function(id, photo,type){
		if(photo==0||photo==1){
			return 'http://img.fengbolive.com/pic/avatar/smallHeadForAuthFail.png';
		}
		if(type==1){
			return 'https://img.fengbolive.com/pic/avatar/'+id+'_'+photo+'_720*720.jpg';
		}else{
	        return 'https://img.fengbolive.com/pic/avatar/'+id+'_'+photo+'_200*200.jpg';
		} 
	},
	defaultPic:function(event){
		var img=event.srcElement;
        img.src=location.protocol+"//img.fengbolive.com/pic/avatar/default.png";
        img.onerror=null;
	},
	setCookie:function(c_name,value,expiredays){
	    var exp = new Date();
	    exp.setTime(exp.getTime() + expiredays*24*60*60*1000);
	    document.cookie = c_name + "="+ escape (value) + ";expires=" + exp.toGMTString()+";path=/";
	},
	cjcookie:function(c_name,value,expiredays,path,domain){
		var exp = new Date();
	    exp.setTime(exp.getTime() + expiredays*24*60*60*1000);
		document.cookie = c_name + "="+ escape (value) + ";expires=" + exp.toGMTString()+";path="+path+";domain="+domain;
	},
	getCookie:function(c_name){
		var arr,reg=new RegExp("(^| )"+c_name+"=([^;]*)(;|$)"); //正则匹配
	    if(arr=document.cookie.match(reg)){
	      return unescape(arr[2]);
	    }
	    else{
	     return null;
	    }
	},
	delCookie:function(name,path,domain){
		var exp = new Date();
		exp.setTime(exp.getTime() - 1);
		var cval=this.getCookie(name);
		if(cval!=null){
			if(domain){
				document.cookie= name + "="+cval+";expires="+exp.toGMTString()+";path="+path+";domain="+domain;
			}else{
				document.cookie= name + "="+cval+";expires="+exp.toGMTString()+";path=/";
			}
		}
	},
	changeobj:function(val){//传入对象类型的参数
      var str='';
      if(typeof val!=='object'){
        return val;
      }
      for(var el in val){
        str+=el+'='+val[el]+'&';
      }
      str=str.substr(0,str.length-1);
      return str;
    }
}